import { useQuery } from 'hooks/useCustomQuery';
import getAllWholesalers from '@/API/Wholesaler/getAllWholesalers';

const useGetWholesalerList = (setWholesalers, enabled = true) => {
    return useQuery({
        queryKey: ['wholesalerList'],
        queryFn: async () => {
            try {
                const data = await getAllWholesalers();
                setWholesalers(data);
                return data;
            } catch (error) {
                throw new Error('Error fetching wholesaler list');
            }
        },
        refetchOnWindowFocus: false,
        staleTime: 0,
        enabled: enabled,
    });
};

export default useGetWholesalerList;
